<template>
  <div class="item-card">
    <v-card v-if="!required" tile :elevation="!cardElevation ? 0 : 1"
            :class="wasRequired ? 'required-border-green pa-2' : 'pa-2'" @click="viewItem"
            :min-height="height ? height : ''">
      <div v-show="errorBadgeText" class="error-badge">
        <p class="mb-0">{{ errorBadgeText }}</p>
      </div>

      <v-row justify="space-between" no-gutters>
        <v-col cols="6" md="5" lg="4" v-if="!hideChart">
          <!-- TODO uncomment and install apexcharts and vue-apexcharts if score is added to building backend -->
          <!-- <VueApexCharts width="140" type="radialBar" :options="chartOptions" :series="item.score"/> -->
        </v-col>
        <v-col v-if="showProfile">
          <v-avatar size="40">
            <v-img
                src="@/assets/default_profile_pic.png"
            ></v-img>
          </v-avatar>
        </v-col>
        <v-col v-else></v-col>
        <v-col class="text-right">
          <v-tooltip bottom :disabled="!viewBtnTooltip">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                  v-if="!hideViewBtn"
                  class="mr-2"
                  icon
                  @click.native.stop="viewItem(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon color="primary">visibility</v-icon>
              </v-btn>
            </template>
            <span>{{ viewBtnTooltip }}</span>
          </v-tooltip>

          <v-tooltip bottom :disabled="!extraIconTooltip">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                  v-if="extraIcon"
                  @click.native.stop="extraIconAction"
                  icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon>{{ extraIcon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ extraIconTooltip }}</span>
          </v-tooltip>

          <v-btn
              v-if="showDelete"
              class="text-capitalize"
              @click.native.stop="deleteItem(item)"
              text
              small
              color="errorDark"
          >
            {{ $t('buttons:delete') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-card-title>
        <div v-if="leftCornerIconSource" class="mr-2">
          <v-img :src="leftCornerIconSource"></v-img>
        </div>
        <p :class="warningTitle ? 'scaleRed--text' : ''">{{ title }} <span class="font-weight-light">{{ titleExtra }}</span></p>
      </v-card-title>

      <v-card-subtitle v-if="subtitle || subtitle2 || subtitle3">
        <p class="pb-2" v-show="subtitle">{{ subtitle }}</p>
        <p :class="subtitle3 ? 'pb-2' : ''" v-show="subtitle2">{{ subtitle2 }}</p>
        <p v-show="subtitle3">{{ subtitle3 }}</p>
      </v-card-subtitle>

      <v-card-text v-if="description">
        <p>{{ description }}</p>
      </v-card-text>

      <v-card-actions
          v-if="(!hideActionBtn1 || !hideActionBtn2 || !hideActionBtn3) && $vuetify.breakpoint.smAndUp"
          :class="bitmapPath ? '' : 'image-space'"
      >
        <v-tooltip bottom :disabled="!actionBtn1Tooltip">
          <template v-slot:activator="{ on, attrs}">
            <v-btn
                rounded
                color="primary"
                class="elevation-0 mx-2"
                @click.native.stop="cardAction1(item)"
                v-show="!hideActionBtn1"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon>add</v-icon>
              {{ actionBtn1Text }}
            </v-btn>
          </template>
          <span>{{ actionBtn1Tooltip }}</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="!actionBtn2Tooltip">
          <template v-slot:activator="{ on, attrs}">
            <v-btn
                rounded
                color="primary"
                class="elevation-0 mx-2"
                @click.native.stop="cardAction2(item)"
                v-show="!hideActionBtn2"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon>add</v-icon>
              {{ actionBtn2Text }}

            </v-btn>
          </template>
          <span>{{ actionBtn2Tooltip }}</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="!actionBtn3Tooltip">
          <template v-slot:activator="{ on, attrs}">
            <v-btn
                rounded
                color="primary"
                class="elevation-0 mx-2"
                @click.native.stop="cardAction3(item)"
                v-show="!hideActionBtn3"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon>add</v-icon>
              {{ actionBtn3Text }}
            </v-btn>
          </template>
          <span>{{ actionBtn3Tooltip }}</span>
        </v-tooltip>
        <v-spacer/>
        <v-img v-if="bitmapPath"
               :src="bitmapPath"
               aspect-ratio="1"
               contain
               max-height="80"
               class="ml-2"
        >
        </v-img>

      </v-card-actions>
      <v-card-actions v-else-if="!hideActionBtn1 || !hideActionBtn2 || !hideActionBtn3">
        <v-row>
          <v-col cols="12" class="pt-0">
            <v-tooltip bottom :disabled="!actionBtn1Tooltip">
              <template v-slot:activator="{ on, attrs}">
                <v-btn
                    rounded
                    color="primary"
                    class="elevation-0"
                    @click.native.stop="cardAction1(item)"
                    v-show="!hideActionBtn1"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>add</v-icon>
                  {{ actionBtn1Text }}
                </v-btn>
              </template>
              <span>{{ actionBtn1Tooltip }}</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" class="pt-0">
            <v-tooltip bottom :disabled="!actionBtn2Tooltip">
              <template v-slot:activator="{ on, attrs}">
                <v-btn
                    rounded
                    color="primary"
                    class="elevation-0"
                    @click.native.stop="cardAction2(item)"
                    v-show="!hideActionBtn2"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>add</v-icon>
                  {{ actionBtn2Text }}
                </v-btn>
              </template>
              <span>{{ actionBtn2Tooltip }}</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" class="pt-0">
            <v-tooltip bottom :disabled="!actionBtn3Tooltip">
              <template v-slot:activator="{ on, attrs}">
                <v-btn
                    rounded
                    color="primary"
                    class="elevation-0"
                    @click.native.stop="cardAction3(item)"
                    v-show="!hideActionBtn3"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>add</v-icon>
                  {{ actionBtn3Text }}
                </v-btn>
              </template>
              <span>{{ actionBtn3Tooltip }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-card v-else tile :elevation="!cardElevation ? 0 : 1" class="pa-2 required-border" @click="viewItem"
            :min-height="height ? height : ''" style="display: flex; flex-direction: column">
      <v-card-title style="flex: 1; justify-content: center">
        <div v-if="leftCornerIconSource">
          <v-img height="32" contain :src="leftCornerIconSource"></v-img>
        </div>
        <p class="scaleRed--text">{{ title }} <span class="font-weight-light">{{ titleExtra }}</span></p>
      </v-card-title>
      <v-card-text class="text-center" style="flex: 1; justify-content: center">
        <v-btn class="no-text-transform" text small>{{ requiredBtnText }}</v-btn>
      </v-card-text>
    </v-card>
  </div>

</template>
<script>
// TODO uncomment if score is added to building backend
// import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ItemCard',
  // TODO uncomment if score is added to building backend
  // components: {
  //   VueApexCharts
  // },
  props: {
    item: Object, // item data to display
    actionBtn1Text: String, // Text for first action button
    actionBtn2Text: String, // ^ for second
    actionBtn3Text: String, // ^ for third
    actionBtn1Tooltip: String, // Text for first action button tooltip
    actionBtn2Tooltip: String, // ^ for second
    actionBtn3Tooltip: String, // ^ for third

    title: String, // title of card
    titleExtra: String, // extra title string which font will be lighter than the title itself
    subtitle: String, // subtitle of card
    subtitle2: String, // ^ second
    subtitle3: String, // ^ third
    description: String, // additional text
    bitmapPath: String,
    hideChart: Boolean, // hide scale chart
    hideActionBtn1: Boolean, // hide first action Btn
    hideActionBtn2: Boolean, // ^ for second
    hideActionBtn3: Boolean, // ^ for third
    hideViewBtn: Boolean, // hide eye btn
    viewBtnTooltip: String, // Text for view btn tooltip
    cardElevation: Boolean, // if card elevation should be shown
    showDelete: Boolean, //show delete Btn
    showProfile: Boolean,
    extraIcon: String, // extra Icon in top right corner
    extraIconTooltip: String, // Text for extra icon tooltip
    required: Boolean, // bool to set additional styling for required items
    requiredBtnText: String, // Text for required btn
    wasRequired: Boolean, // if item has required attribute
    height: String, // set height of card

    leftCornerIconSource: String, // Source of icon which should be placed in the left top corner
    errorBadgeText: String, // Text for error badge
    warningTitle: Boolean, // if the title should be displayed as a warning
  },
  data() {
    return {
      // TODO uncomment if score is added to building backend
      // options for apex score chart
      // chartOptions: {
      //   chart: {
      //     type: 'radialBar',
      //     sparkline: {
      //       enabled: true
      //     },
      //     offsetX: -10
      //   },
      //   plotOptions: {
      //     radialBar: {
      //       startAngle: -90,
      //       endAngle: 90,
      //       dataLabels: {
      //         name: {
      //           show: false
      //         },
      //         value: {
      //           offsetY: -2,
      //           fontSize: '14px'
      //         }
      //       }
      //     }
      //   },
      //   fill: {
      //     type: 'solid',
      //     colors: [function({ value}) {
      //       if(value < 20) {
      //         return '#F44336'
      //       } else if (value >= 20 && value < 40) {
      //         return '#EF6C00'
      //       } else if (value >= 40 && value < 60) {
      //         return '#FF9800'
      //       } else if (value >= 60 && value < 80) {
      //         return '#8BC34A'
      //       } else {
      //         return '#4CAF50'
      //       }
      //     }]
      //   }
      // },
    }
  },
  methods: {
    viewItem(item) {
      this.$emit('viewItem', item);
    },
    extraIconAction(item) {
      this.$emit('extraIconAction', item);
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    cardAction1(item) {
      this.$emit('cardAction1', item);
    },
    cardAction2(item) {
      this.$emit('cardAction2', item);
    },
    cardAction3(item) {
      this.$emit('cardAction3', item);
    }
  }
}
</script>
<style lang="scss">
.item-card {
  .v-card__title {
    p {
      font-size: 1.2rem !important;

      span {
        font-size: 1rem !important;
      }
    }
  }

  .v-card__subtitle {
    p {
      font-size: 1rem !important;
    }
  }

  .v-application .elevation-1 {
    box-shadow: 0 2px 3px 0 #e8eafc, 0 1px 1px -2px #b2b2b21a, 0 1px 1px 0 #9a9a9a1a !important;
  }

  .image-space {
    height: 96px;
  }

  .required-border {
    border-bottom: 5px solid var(--v-scaleRed-base) !important;
  }

  .required-border-green {
    border-bottom: 5px solid var(--v-scaleGreen-base) !important;
  }
}

.error-badge {
  background-color: #df5e63;
  top: 0;
  position: absolute;
  z-index: 1;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  padding: 10px;
  right: 30%;

  outline: 3px solid #df5e63;
  border-left: 2px solid white;
  border-right: 2px solid white;
  border-bottom: 2px solid white;

  p {
    color: white;
    font-weight: bold;
  }
}
</style>